import { Polygon } from 'app/agriculture/FarmMain/MapRenderer/renderers/Polygon';
import { useEntities } from 'app/agriculture/queries/entities/useEntities';
import { getAssetIconConfig } from 'app/agriculture/icons/utils/map-icon-utils/getAssetIconConfig';
import { useMemo } from 'react';
import { createOverlayIconDataUri } from 'app/agriculture/icons/utils/map-icon-utils/createOverlayIconDataUri';
import { PolygonEntityTypes } from 'app/agriculture/models/Entities';
import { InfraType } from 'app/agriculture/mutations/types/entityConfig';

export function PolygonRenderer({
    entityType,
}: {
    entityType: (typeof PolygonEntityTypes)[number] & InfraType;
}) {
    const entities = useEntities(entityType);
    const { borderColor = '#FFFFFF' } = getAssetIconConfig(entityType).options ?? {};

    const image = useMemo(() => {
        const { icon, options } = getAssetIconConfig(entityType);
        return !icon ? null : createOverlayIconDataUri(icon, options);
    }, [entityType]);

    return (
        <>
            {Array.from(entities).map(([id, { geometry, pole }]) => (
                <Polygon
                    key={id}
                    image={image}
                    id={id}
                    allowPicking={entityType !== 'Boundary'}
                    geometry={geometry}
                    pole={pole}
                    borderColor={Cesium.Color.fromCssColorString(borderColor)}
                />
            ))}
        </>
    );
}
